import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Checkbox, Table, Button } from "antd";
import styles from "./manageAdminPage.scss";
import PaginationUser from "../PaginationUser/PaginationUser";
import CreateAdminPopup from "./CreateAdminPopup";
import {
  getAdminUsers,
  blockAdmin,
  unblockAdmin,
  selectAll,
  changePage
} from "./admin.ducks";
import {
  getBlockReasons,
  selectBlockReasons,
} from "../ManageUserPage/user.ducks";
import { ReasonPickerModal } from "../ReasonPickerModal";
import { UserRole } from "../../../models";
import { UserI } from "../../../typings/interfaces";

interface ManageAdminPage {
  history: History;
  location: Location;
  match: {
    path: string;
    url: string;
    isExact: boolean;
    params: {};
  };
  user: UserI;
  admins: {
    id: string;
    isBlocked: boolean;
    registrationDate: string;
    role: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    isVerified: boolean;
  }[];
  page: number;
  itemPerPage: number;
  total: number;
  blockAdmin: (id: string, blockReasonId: number, note: string, callback: (success: boolean) => void) => void;
  changePage: (page: number) => void;
  getAdminUsers: (
    page: number,
    itemPerPage: number,
    callback?: () => void
  ) => void;
  unblockAdmin: (id: string) => void;
  getBlockReasons: () => void;
  blockReasons: { id: number; name: string }[];
}

const ManageAdminPage = (props: ManageAdminPage) => {
  const { page, admins, itemPerPage, total } = props;

  const [createPopupVisible, setCreatePopupVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pendingBlock, setPendingBlock] = useState(null);
  const [blockModalLoading, setBlockModalLoading] = useState(false);

  useEffect(() => {
    const { page, itemPerPage, getAdminUsers } = props;
    setLoading(true);
    getAdminUsers(page, itemPerPage, () => setLoading(false));
  }, [page]);

  useEffect(() => {
    if (!props.blockReasons || !props.blockReasons.length) {
      props.getBlockReasons();
    }
  }, []);

  const columns = [
    {
      title: "Korisničko ime",
      dataIndex: "username",
      key: "username"
    },
    {
      title: "Ime",
      dataIndex: "firstName",
      key: "firstName"
    },
    {
      title: "Prezime",
      dataIndex: "lastName",
      key: "lastName"
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Uloga",
      dataIndex: "role",
      key: "role",
      render: value => {
        switch (value) {
          case UserRole.admin:
            return "Operater";

          case UserRole.superAdmin:
            return "Administrator";

          default:
            return value;
        }
      }
    },
    {
      title: "Aktivan",
      dataIndex: "isBlocked",
      key: "isBlocked",
      align: "center",
      render: (value, record) => (
        <Checkbox
          onChange={() => activeOnChange(record)}
          defaultChecked={!value}
        />
      )
    },
    {
      title: "Validiran",
      dataIndex: "isVerified",
      key: "isVerified",
      align: "center",
      render: value => <Checkbox disabled defaultChecked={value} />
    }
  ];

  const handlePageChange = page => {
    props.changePage(page); // ~ we should pass this function directly to onPageChange
  };

  const activeOnChange = record => {
    const { unblockAdmin } = props;
    const { id, isBlocked, username } = record;
    if (isBlocked) {
      unblockAdmin(id);
      record.isBlocked = false; // eslint-disable-line
      return;
    }
    setPendingBlock({ userId: id, username, record });
  };

  const handleBlockCancel = () => {
    if (blockModalLoading) return;
    setPendingBlock(null);
  };

  const handleBlockConfirm = (reasonId, note, basedOn) => {
    if (!pendingBlock) return;
    setBlockModalLoading(true);
    props.blockAdmin(pendingBlock.userId, reasonId, note, basedOn, (success) => {
      setBlockModalLoading(false);
      if (!success) return;
      pendingBlock.record.isBlocked = true; // eslint-disable-line
      setPendingBlock(null);
    });
  };

  const showCreateAdminPopup = e => {
    e.preventDefault();
    setCreatePopupVisible(true);
  };

  const handleCreateAdminDismiss = () => {
    const { page, itemPerPage, getAdminUsers } = props;

    getAdminUsers(page, itemPerPage);
    setCreatePopupVisible(false);
  };

  return (
    <React.Fragment>
      <CreateAdminPopup
        onDismiss={handleCreateAdminDismiss}
        isVisible={createPopupVisible}
      />

      <h1 className="child-center">{"UPRAVLJANJE ADMINISTRATOROM"}</h1>

      <Button
        type="primary"
        className={styles.createButton}
        onClick={showCreateAdminPopup}
      >
        {"Stvorite novog administratora"}
      </Button>

      <Table
        rowKey="username"
        bordered
        dataSource={admins}
        // @ts-ignore
        columns={columns}
        // @ts-ignore
        rowClassName="child-center"
        className={`admin-table ${styles.table}`}
        pagination={false}
        loading={loading}
      />
      <PaginationUser
        pageSize={itemPerPage}
        total={total}
        className={styles.pagination}
        current={page}
        onPageChange={handlePageChange}
      />

      <ReasonPickerModal
        visible={!!pendingBlock}
        title={
          pendingBlock && pendingBlock.username
            ? `Deaktiviraj administratora ${pendingBlock.username}`
            : "Deaktiviraj administratora"
        }
        reasons={props.blockReasons || []}
        submitText="Deaktiviraj"
        loading={blockModalLoading}
        onCancel={handleBlockCancel}
        onConfirm={handleBlockConfirm}
      />
    </React.Fragment>
  );
};

ManageAdminPage.defaultProps = {
  admins: [],
  page: 1,
  itemPerPage: 10,
  total: 0
};

export default connect(
  state => ({
    ...selectAll(state),
    blockReasons: selectBlockReasons(state),
  }),
  {
    getAdminUsers,
    changePage,
    blockAdmin,
    unblockAdmin,
    getBlockReasons,
  }
)(ManageAdminPage);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdminPage/ManageAdminPage.tsx